import React from "react"
import ReactMarkdown, { Components } from "react-markdown"
import rehypeRaw from "rehype-raw"
import remarkBreaks from "remark-breaks"
import remarkGfm from "remark-gfm"

export function Markdown({
    children,
    className,
    components,
}: {
    children: string
    className?: string
    components?: Components
}) {
    const baseComponents = {
        table: (props: React.HTMLAttributes<HTMLTableElement>) => (
            <table
                className="not-prose w-full table-auto border-collapse text-sm"
                {...props}
            />
        ),

        th: (props: React.HTMLAttributes<HTMLTableCellElement>) => (
            <th
                className="border-border-muted border-b px-3 py-2 text-left font-bold"
                {...props}
            />
        ),

        tr: (props: React.HTMLAttributes<HTMLTableRowElement>) => (
            <tr
                className="border-border-muted border-b last:border-0"
                {...props}
            />
        ),

        td: (props: React.HTMLAttributes<HTMLTableCellElement>) => (
            <td className="px-3 py-2" {...props} />
        ),

        blockquote: (props: React.HTMLAttributes<HTMLQuoteElement>) => (
            <blockquote
                className="border-border-muted border-l-border-muted border-l-4 px-4 py-2"
                {...props}
            />
        ),
        h1: (props: React.HTMLAttributes<HTMLHeadingElement>) => (
            <h1 className="text-text-primary text-2xl font-bold" {...props} />
        ),
        h2: (props: React.HTMLAttributes<HTMLHeadingElement>) => (
            <h2 className="text-text-primary text-xl font-bold" {...props} />
        ),
        h3: (props: React.HTMLAttributes<HTMLHeadingElement>) => (
            <h3 className="text-text-primary text-lg font-bold" {...props} />
        ),
        em: (props: React.HTMLAttributes<HTMLElement>) => (
            <em className="text-text-primary italic" {...props} />
        ),
        p: (props: React.HTMLAttributes<HTMLParagraphElement>) => (
            <p className="text-text-primary text-sm" {...props} />
        ),
        ul: (props: React.HTMLAttributes<HTMLUListElement>) => (
            <ul className="list-inside list-disc" {...props} />
        ),
        ol: (props: React.HTMLAttributes<HTMLOListElement>) => (
            <ol className="list-inside list-decimal" {...props} />
        ),
        a: (props: React.HTMLAttributes<HTMLAnchorElement>) => (
            <a
                className="text-link hover:text-link-hover cursor-pointer underline"
                {...props}
            />
        ),

        ...components,
    }

    return (
        <div className={`my-2 text-sm leading-relaxed ${className}`}>
            <ReactMarkdown
                remarkPlugins={[remarkGfm, remarkBreaks]}
                rehypePlugins={[rehypeRaw]}
                components={baseComponents}
            >
                {children}
            </ReactMarkdown>
        </div>
    )
}
